<template>
    <div class="left-box">
        <div class="introduction" style="min-height: 15rem;">
            <div  v-if="detail.courseDescription">
                <div v-for="(item,index) in stringToArray(detail.courseDescription)" :key="index">{{ item }}</div>
            </div>
            <no-data v-else></no-data>
        </div>
        <el-tabs v-model="activeName" style="margin-top: 2rem;" @tab-click="handleClick">
            <el-tab-pane v-for="(item,index) in tabList" :key="index" :label="item.label" :name="item.value">
                <div class="tab-ele-box">
                    <div class="kcts" v-if="activeName=='kcts'">
                        <div v-if="detail.courseFeature">
                            <div v-for="(item,index) in stringToArray(detail.courseFeature)" class="kcts-item" :key="index">
                                <img src="../../../assets/image/course/kcts.png" style="width: 4rem;" alt="">
                                <p v-if="item">{{ item }}</p>
                            </div>
                        </div>
                        <no-data v-else></no-data>
                    </div>
                    <div class="kcmb" v-else-if="activeName=='kcmb'">
                        <div class="target" v-if="detail.courseTarget">
                            <div v-for="(item,index) in stringToArray(detail.courseTarget)" class="kcmb-item" :key="index">
                                <img src="../../../assets/image/course/kcmb.png" style="width: 2.3rem;"  alt="">
                                <p v-if="item">{{ item }}</p>
                            </div>
                        </div>
                        <no-data v-else></no-data>
                    </div>
                    <div class="kcsj" v-else-if="activeName=='kcsj'">
                        <div class="target" v-if="detail.courseDesign">
                            <div v-for="(item,index) in stringToArray(detail.courseDesign)" class="kcsj-item" :key="index">
                                <img src="../../../assets/image/course/kcsj.png" style="width: 2.3rem;height: auto;object-fit: cover;" alt="">
                                <p v-if="item">{{ item }}</p>
                            </div>
                        </div>
                        <no-data v-else></no-data>
                    </div>
                    <div class="jxtd" v-else-if="activeName=='jxtd'">
                        <div v-for="(item,index) in teachTeam" class="user-item" :key="index">
                            <div class="top-user">
                                <img :src="item.avatar?$severUrl(item.avatar):$user" alt="">
                                <div>
                                    <p class="name">{{ item.teacherName||'暂无' }}</p>
                                    <p class="job">{{ item.rank }}</p>
                                    <div class="account-box">
                                        <i class="iconfont icon-twitter-fill"></i>
                                        <div class="account"></div>
                                        <div class="account"></div>
                                        <div class="account"></div>
                                        <div class="account"></div>
                                        <div class="account"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="describe">{{ item.info }}</div>
                        </div>
                        <no-data v-if="teachTeam.length==0"></no-data>
                    </div>
                    <div class="khbz" v-else-if="activeName=='khbz'">
                        <div class="examine-item" v-if="detail.referenceStandard">
                            <div v-for="(item,index) in stringToArray(detail.referenceStandard)" class="khbz-item" :key="index">
                                <div v-if="item"></div>
                                <p v-if="item">{{ item }}</p>
                            </div>
                        </div>
                        <no-data v-else></no-data>
                    </div>
                    <div class="ckjc" v-else>
                        <div v-for="(item,index) in setup" class="reference-item" :key="index">
                            <div class="item-box">
                                <img :src="item.coverPath?$severUrl(item.coverPath):$default" alt="">
                                <div>
                                    <p>{{ item.name }}</p>
                                    <div class="file-ele" v-if="item.fileId" @click="downloadFile(item)"><i class="iconfont icon-fujian"></i>{{ item.fileName }}</div>
                                </div>
                            </div>
                            <div class="describe">{{ item.describe }}</div>
                        </div>
                        <no-data v-if="setup&&setup.length==0"></no-data>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { numberToChinese } from '@/utils/utils';
import { MainResourcePreview } from '@/api/course/course';
import { GetList } from '@/api/textBook';
import { StudyCourse } from '@/api/study';
import { ossFileDownload } from '@/assets/js/oss';
import { GetTeamList } from '@/api/teachTeam';
import NoData from '../../common/NoData.vue';
    export default {
    props:{
        id:{
            default:''
        }
    },
  components: { NoData },
        data(){
            return {
                /**tab切换绑定值 */
                activeName:'kcts',
                /**课程设置绑定tab */
                settingActive:'kcnr',
                /**tab切换 */
                tabList:[
                    {
                        label:'课程特色',
                        value:'kcts',
                    },
                    {
                        label:'课程目标',
                        value:'kcmb'
                    },
                    {
                        label:'课程设计',
                        value:'kcsj'
                    },
                    {
                        label:'教学团队',
                        value:'jxtd'
                    },
                    {
                        label:'参考标准',
                        value:'khbz'
                    },
                    {
                        label:'参考教材',
                        value:'ckjc'
                    },
                ],
                /**课程设置tab切换 */
                settingTab:[
                    {
                        label:'课程内容',
                        value:'kcnr',
                        data:[
                            {
                                chapter:' 智能建造关键技术',
                                children:[
                                    {
                                        title:'智能建造背景及概念',
                                        fileList:[
                                            {
                                                fileName:'虚仿.doc'
                                            }
                                        ]
                                    },
                                    {
                                        title:'智能建造背景及概念'
                                    },
                                    {
                                        title:'智能建造背景及概念'
                                    },
                                ]
                            },
                            {
                                chapter:' 智能建造关键技术',
                                children:[
                                    {
                                        title:'智能建造背景及概念',
                                    },
                                    {
                                        title:'智能建造背景及概念'
                                    },
                                    {
                                        title:'智能建造背景及概念'
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        label:'参考标准',
                        value:'khbz'
                    },
                    {
                        label:'参考教材',
                        value:'ckjc'
                    },
                ]
            }
        },
        methods:{
            numberToChinese,
            /**字符串转数组 */
            stringToArray(str){
                let arr=[];
                if(!str)return arr;
                else{
                    let arr1=str.split('\n');
                    arr1.forEach(item=>{
                        if(item){
                            arr.push(item);
                        }
                    })
                }
                return arr;
            },
            handleClick(){
                if(this.activeName=='ckjc'){
                    this.selectReference();
                }else if(this.activeName=='jxtd'){
                    this.selectTeachTeam();
                }
            },
            /**下载附件 */
            downloadFile(item){
                ossFileDownload(item.fileId);
            },
             /**课程教学团队查询 */
             selectTeachTeam(){
                GetTeamList({courseId:this.courseId}).then(res=>{
                    if(res.code==200){
                        var data=res.data||[];
                        var params={
                                label:'teachTeam',
                                value:data
                            }
                        this.$store.commit('course/changeCourseDetail',params);
                    }
                })
            },
            /**课程参考资料查询 */
            selectReference(){
                var params={
                "courseId":this.courseId,
                }
                GetList(params).then(res=>{
                    if(res.code==200){
                        var data=res.data;
                        var params={
                                label:'setup',
                                value:data
                            }
                        this.$store.commit('course/changeCourseDetail',params);
                    }
                })
            },
        },
        mounted(){
        },
        computed:{
            /**课程详情 */
            detail(){
                return this.$store.state.course.courseDetailData.detail;
            },
            /**教学团队 */
            teachTeam(){
                return this.$store.state.course.courseDetailData.teachTeam;
            },
            /**参考教材 */
            setup(){
                return this.$store.state.course.courseDetailData.setup;
            },
            courseId(){
                return this.$route.query.id||this.id;
            }
        }
    }
</script>

<style lang="less" scoped>
.left-box{
    padding-top: 2rem;
}
.title{
    color: #151C34;
    font-size: 2rem;
}
.introduction{
    color: #334681;
    line-height: 3rem;
    margin-top: 2.4rem;
    word-break: break-all;
    white-space: pre-wrap;
}
.tab-ele-box{
    // height: 21.5rem;
}
.kcts,.kcmb,.kcsj,.jxtd,.kcpj{
    height: 100%;
}
.kcts{
    color: #334681;
    width: 100%;
    .kcts-item{
    display: flex;
    margin-top: 2.5rem;
    align-items: flex-start;
    &> :nth-child(2){
            width: 100%;
            font-size: 14px;
            white-space: var(--lineWrap);
            word-wrap: break-word;
            margin-left: 1rem;
        }
}
}
.tab-box{
    display: flex;
    cursor: pointer;
    &> :nth-child(2){
        margin-left: 2rem;
    }
}
.target{
    color: #334681;
    .kcmb-item{
        display: flex;
        margin-top: 2.5rem;
        align-items: flex-start;
    &> :nth-child(2){
        flex: 1;
        white-space: var(--lineWrap);
        margin-left: 1.5rem;
        word-wrap: break-word;
    }
    }
    .kcsj-item{
        margin-top: 2.5rem;
        display: flex;
        align-items: flex-start;
    &> :nth-child(2){
        flex: 1;
        margin-left: 1.5rem;
        white-space: var(--lineWrap);
        word-wrap: break-word;
    }
    }
}
.child-top{
    margin-top: 2rem;
}
.user-item{
    margin-top: 4rem;
}
.top-user{
    display: flex;
    img{
        width: 9rem;
        height: 9rem;
        border-radius: 50%;
        object-fit: cover;
    }
    &> :nth-child(2){
        margin-top: 1rem;
        margin-left: 1.5rem;
        .name{
            color: #2576E5;
            font-size: 14px;
        }
        .job{
            color: #2D3035;
            font-size: 12px;
        }
    }
}
.icon-twitter-fill{
    color: #FF531E;
}
.describe{
    color: #334681;
    white-space: var(--lineWrap);
    margin-top: 1.5rem;
}
.account-box{
    display: flex;
    align-items: center;
    margin-top: 1rem;
}
.account{
    width: 14px;
    height: 14px;
    background-color: #939AA2;
    border-radius: 3px;
    margin-left: 1rem;
}
.ckjc{
    &> :nth-child(n){
        margin-top: 2rem;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
}
.item-box{
    display: flex;
    align-items: center;
    img{
        width: 9rem;
        height: 9rem;
        object-fit: cover;
        border-radius: 50%;
    }
    &> :nth-child(2){
        color: #334681;
        margin-left: 2rem;
        &> :nth-child(1){
            font-weight: 700;
        }
    }
}
.examine-item{
    color: #334681;
    &> :nth-child(n){
        margin-top: 2.5rem;
    }
    .khbz-item{
        display: flex;
        &> :nth-child(1){
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #FF531E;
        margin-right: 1.5rem;
        margin-top: 0.65rem;
    }
    &> :nth-child(2){
        flex: 1;
        white-space: var(--lineWrap);
    }
    }
}
.file-ele{
    color: var(--blue);
    display: flex;
    align-items: center;
    cursor: pointer;
}
</style>